import script from "./relNormal.vue?vue&type=script&setup=true&lang=ts"
export * from "./relNormal.vue?vue&type=script&setup=true&lang=ts"

import "./relNormal.vue?vue&type=style&index=0&id=671473e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-671473e4"]])

export default __exports__